import { Link } from 'react-router-dom';
import { getLatestArticles, getHotArticles } from '@/mocks/articles';

export default function ArticleGrid() {
  const hotArticles = getHotArticles();
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Hot Section */}
        <div className="mb-16">
          <div className="flex items-center justify-between mb-8">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                </div>
                <span className="text-accent-600 text-xs font-label font-semibold tracking-wider uppercase">HOT</span>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                今日热门爆料
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {hotArticles.map((article, index) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  {/* Hot badge for the first one */}
                  {index === 0 && (
                    <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                      爆
                    </div>
                  )}
                  <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-secondary-900/70 text-background-50 text-xs whitespace-nowrap">
                    {article.category}
                  </div>
                </div>

                <div className="p-5">
                  <h3 className="font-label text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-xs leading-relaxed mb-4 line-clamp-2">
                    {article.summary}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-foreground-500 text-xs">
                      {article.publishedAt}
                    </span>
                    <div className="flex items-center gap-3 text-foreground-500 text-xs">
                      <span className="flex items-center gap-1">
                        <div className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-eye-line text-[10px]"></i>
                        </div>
                        {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <div className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-chat-3-line text-[10px]"></i>
                        </div>
                        {article.comments}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Latest Section */}
        <div>
          <div className="flex items-center justify-between mb-8">
            <div>
              <span className="text-foreground-500 text-xs font-label tracking-wider uppercase">最新更新</span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-1">
                最新吃瓜文章
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-background-300/60 transition-all cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-secondary-900/70 text-background-50 text-xs whitespace-nowrap">
                    {article.category}
                  </div>
                </div>

                <div className="p-5">
                  <h3 className="font-label text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-700 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-xs leading-relaxed mb-4 line-clamp-2">
                    {article.summary}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-foreground-500 text-xs">
                      {article.publishedAt}
                    </span>
                    <div className="flex items-center gap-3 text-foreground-500 text-xs">
                      <span className="flex items-center gap-1">
                        <div className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-eye-line text-[10px]"></i>
                        </div>
                        {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <div className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-chat-3-line text-[10px]"></i>
                        </div>
                        {article.comments}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}